// extracted by mini-css-extract-plugin
export default {"heading":"pr-z","signin":"qr-z","signupBtn":"rr-z","disabled":"sr-z"};